<template>
    <v-container fluid fill-height>
        <v-layout>
            <v-flex v-if="loading" xs12>
                <v-progress-circular indeterminate></v-progress-circular>
            </v-flex>
            <v-flex v-else-if="error" xs12>
                <v-alert 
                    :value="error != null" 
                    outline 
                    type="error">
                    <span>{{ error }}</span>
                </v-alert>
            </v-flex>
            <v-flex v-else xs12>
                <product-groups-table 
                    :data="data"
                    @add="openAdd"
                    @edit="openEdit">
                </product-groups-table>
            </v-flex>
        </v-layout>
        <v-dialog 
            :value="editing"
            fullscreen 
            hide-overlay 
            transition="dialog-bottom-transition">
            <product-groups-edit 
                v-if="editing"
                :data="editData"
                :availableCategories="availableCategories"
                :submit-loading="submitLoading"
                :submit-error="submitError"
                @submit="handleSubmit"
                @cancel="closeEdit">
            </product-groups-edit>
        </v-dialog>
    </v-container>
</template>

<script>
import ProductGroupsTable from "@/components/configuration/productGroups/ProductGroupsTable.vue";
import ProductGroupsEdit from "@/components/configuration/productGroups/ProductGroupsEdit.vue";
import BaseApi from "@/api/baseApi";
import ProductGroupApi from "@/api/productGroupApi";
import ProductCategoryApi from "@/api/productCategoryApi";

export default {
    components: {
        ProductGroupsTable,
        ProductGroupsEdit
    },
    data(){
        return {
            loading: false,
            error: null,
            availableCategories: [],
            data: [],
            editing: false,
            editIndex: null,
            editData: null,
            submitLoading: false,
            submitError: null
        };
    },
    created(){
        this.load();
    },
    methods: {
        async load(){
            this.loading = true;

            try {
                let productGroups = await ProductGroupApi.getProductGroups();
                let productCategories = await ProductCategoryApi.getProductCategories();

                this.availableCategories = productCategories.map(x => {
                    return {
                        ProductCategoryID: x.ID,
                        ProductCategoryName: x.Name
                    };
                });
                this.data = productGroups.map(this.mapToData);
            } catch(err){
                this.error = await BaseApi.parseHttpRequestError(err);
            }

            this.loading = false;
        },
        mapToData(apiProductGroup){
            let productCategory = this.availableCategories.find(
                y => y.ProductCategoryID == apiProductGroup.ProductCategoryID
            );

            return {
                ProductGroupID: apiProductGroup.ID,
                ProductGroupName: apiProductGroup.Name,
                ProductCategoryID: productCategory == null ? null : productCategory.ProductCategoryID,
                ProductCategoryName: productCategory == null ? null : productCategory.ProductCategoryName,
                Description: apiProductGroup.Description,
                IsActive: apiProductGroup.IsActive
            };
        },
        openAdd(){
            this.editing = true;
            this.editIndex = null;
            this.editData = null;
            this.submitLoading = false;
            this.submitError = null;
        },
        openEdit(index){
            this.editing = true;
            this.editIndex = index;
            this.editData = this.data[index];
            this.submitLoading = false;
            this.submitError = null;
        },
        closeEdit(){
            this.editing = false;
            this.editIndex = null;
            this.editData = null;
            this.submitLoading = false;
            this.submitError = null;
        },
        mapToApi(dataProductGroup){
            return {
                ID: dataProductGroup.ProductGroupID,
                Name: dataProductGroup.ProductGroupName,
                ProductCategoryID: dataProductGroup.ProductCategoryID,
                Description: dataProductGroup.Description,
                IsActive: dataProductGroup.IsActive
            }
        },
        async handleSubmit(requestData){
            this.submitLoading = true;

            try {
                let result = null;
                if(requestData.ProductGroupID != null){
                    result = await ProductGroupApi.updateProductGroup(this.mapToApi(requestData));
                } else {
                    result = await ProductGroupApi.addProductGroup(this.mapToApi(requestData));
                }

                if(result == null){
                    throw Error("No new data was returned from the API.");
                }

                let resultData = this.mapToData(result);
                if(this.editIndex != null){
                    this.data.splice(this.editIndex, 1, resultData);
                } else {
                    this.data.push(resultData);
                }

                this.closeEdit();
            } catch (err){
                this.submitError = await BaseApi.parseHttpRequestError(err);
            }

            this.submitLoading = false;
        }
    }
}
</script>